<template>
  <TransitionRoot as="template" :show="showPIDialog">
    <Dialog
      as="div"
      static
      class="fixed inset-0 z-[999] overflow-y-auto bg-[unset]"
      :open="showPIDialog"
    >
      <div
        class="flex items-end justify-center min-h-screen mt-16 px-4 pt-4 pb-20 text-center sm:block sm:p-0"
      >
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-[0s]"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="inline-block md:p-10 md:pb-12 p-6 overflow-hidden text-left align-bottom transition-all transform border border-brand-green shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full bg-[rgba(0,0,0,0.64)] backdrop-blur-[10px]"
          >
            <div class="absolute top-0 right-0 pt-6 pr-6">
              <button
                type="button"
                class="text-gray-400 transition-all duration-200 bg-brand-gray-900 rounded-md group hover:opacity-80 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="close"
              >
                <span class="sr-only">Close</span>
                <XIcon
                  class="w-6 h-6 duration-500 ease-in-out transform group-hover:scale-110"
                  aria-hidden="true"
                  @click="showPIDialog = false;"
                />
              </button>
            </div>
            <div class="flex flex-col justify-center items-center text-white">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
                  <path d="M34.8972 8.03286C33.6646 8.08992 32.4367 8.40651 31.291 8.97932C31.2578 8.99589 31.225 9.01347 31.1928 9.03203L27.7137 11.0424C27.677 11.0405 27.6402 11.0397 27.6034 11.04H4.29415C4.0503 11.0365 3.8082 11.0816 3.58191 11.1725C3.35562 11.2634 3.14967 11.3984 2.97601 11.5697C2.80235 11.7409 2.66445 11.9449 2.57033 12.1699C2.4762 12.3949 2.42773 12.6363 2.42773 12.8802C2.42773 13.124 2.4762 13.3655 2.57033 13.5905C2.66445 13.8154 2.80235 14.0195 2.97601 14.1907C3.14967 14.3619 3.35562 14.4969 3.58191 14.5878C3.8082 14.6788 4.0503 14.7238 4.29415 14.7204H19.9527L19.1524 15.0534C19.1126 15.0696 19.0735 15.0872 19.035 15.1062C16.9956 16.1258 16.0548 18.2981 16.2579 20.253C16.461 22.2079 17.8606 24.1568 20.1036 24.7169C20.978 24.9348 21.9492 25.062 23.0077 25.062C28.3733 25.062 33.631 23.3901 35.1871 22.8743C36.2104 24.0168 41.2568 29.6562 42.9433 31.3829C44.1646 32.6326 44.2883 33.8527 43.9736 34.7207C43.6589 35.5886 42.9446 36.259 41.3882 36.2637C40.9656 36.265 40.5562 36.4117 40.229 36.6791C39.9017 36.9466 39.6765 37.3186 39.5911 37.7326C39.1323 39.9516 38.3226 40.2665 37.497 40.4833C36.6713 40.7 35.8748 40.512 35.8748 40.512C35.6064 40.4388 35.325 40.4273 35.0515 40.4785C34.7781 40.5296 34.5198 40.6421 34.2961 40.8075C34.0724 40.9728 33.8891 41.1867 33.76 41.4331C33.6308 41.6795 33.5592 41.952 33.5506 42.23C33.5506 42.23 33.4895 43.1802 33.021 43.9936C32.5526 44.807 32.0648 45.4926 29.8797 45.2539C29.416 45.2029 28.9502 45.3299 28.5766 45.6093C28.2029 45.8886 27.9493 46.2995 27.867 46.7587C27.6166 48.1592 26.855 48.7672 25.7129 48.9775C24.5709 49.1878 23.02 48.8138 21.6635 47.4727C19.9267 45.7562 13.5939 39.2979 10.7277 36.3716C9.45864 35.0756 7.72069 34.3493 5.91152 34.3493H4.29415C4.0503 34.3458 3.8082 34.3909 3.58191 34.4818C3.35562 34.5727 3.14967 34.7077 2.97601 34.8789C2.80235 35.0502 2.66445 35.2542 2.57033 35.4792C2.4762 35.7041 2.42773 35.9456 2.42773 36.1895C2.42773 36.4333 2.4762 36.6748 2.57033 36.8998C2.66445 37.1247 2.80235 37.3288 2.97601 37.5C3.14967 37.6712 3.35562 37.8062 3.58191 37.8971C3.8082 37.9881 4.0503 38.0331 4.29415 38.0297H5.91152C6.74244 38.0297 7.52064 38.3566 8.09916 38.9474C10.9671 41.8754 17.2401 48.2751 19.0757 50.0893C21.1923 52.182 23.9216 53.0505 26.379 52.598C28.3716 52.2311 30.1167 50.8414 30.9891 48.8601C33.0877 48.685 34.7001 47.7212 35.6735 46.5718C35.6983 46.5731 35.723 46.5739 35.7478 46.5742C35.7478 46.5742 41.2855 46.6707 44.3666 46.5742C46.5099 46.5077 48.6707 45.7802 50.5773 44.1086C51.4373 43.355 52.472 42.9345 53.5245 42.9345H54.5931C54.837 42.9379 55.0791 42.8929 55.3054 42.802C55.5317 42.711 55.7376 42.576 55.9113 42.4048C56.0849 42.2336 56.2228 42.0296 56.317 41.8046C56.4111 41.5796 56.4596 41.3382 56.4596 41.0943C56.4596 40.8504 56.4111 40.609 56.317 40.384C56.2228 40.159 56.0849 39.955 55.9113 39.7838C55.7376 39.6125 55.5317 39.4775 55.3054 39.3866C55.0791 39.2957 54.837 39.2506 54.5931 39.2541H53.5245C51.4952 39.2541 49.611 40.0631 48.1524 41.3411C46.8128 42.5156 45.7493 42.8498 44.254 42.8962C44.2532 42.8962 44.2524 42.8962 44.2516 42.8962C43.2468 42.9277 41.8475 42.9212 40.5304 42.9201C41.4692 42.1463 42.3111 41.0214 42.8307 39.5177C44.9567 39.0316 46.7587 37.8377 47.4336 35.9762C48.2666 33.6787 47.6187 30.9016 45.5742 28.8095C44.0251 27.2235 37.1471 19.5605 37.1471 19.5605C36.9058 19.2913 36.5906 19.099 36.2407 19.0079C35.8909 18.9167 35.5219 18.9305 35.1799 19.0477C35.1799 19.0477 28.1715 21.3815 23.0077 21.3815C22.2432 21.3815 21.5781 21.292 20.995 21.1467C20.2606 20.9634 19.9831 20.4878 19.9191 19.872C19.8555 19.2597 20.057 18.7191 20.6739 18.4056L26.4341 16.0143C26.5083 15.9831 26.5803 15.9471 26.6498 15.9065L32.9468 12.2668C34.3381 11.5742 35.8164 11.522 37.1567 12.0583L45.4496 15.3745C46.3921 15.7531 47.3984 15.9445 48.4112 15.9448L54.5931 15.9472C54.837 15.9506 55.0791 15.9056 55.3054 15.8147C55.5317 15.7237 55.7376 15.5887 55.9113 15.4175C56.0849 15.2463 56.2228 15.0423 56.317 14.8173C56.4111 14.5923 56.4596 14.3509 56.4596 14.107C56.4596 13.8631 56.4111 13.6217 56.317 13.3967C56.2228 13.1717 56.0849 12.9677 55.9113 12.7965C55.7376 12.6252 55.5317 12.4902 55.3054 12.3993C55.0791 12.3084 54.837 12.2633 54.5931 12.2668L48.4136 12.2644C47.8667 12.2644 47.327 12.1627 46.8226 11.9601C46.821 11.9593 46.8194 11.9585 46.8178 11.9577L38.5249 8.64147C37.3661 8.17781 36.1297 7.9758 34.8972 8.03286Z" fill="white"/>
                </svg>
              </div>
              <div class="text-[27px] mb-2">Řízený networking</div>
              <div class="font-normal opacity-50 text-[14px]">Přihlášením udělujete souhlas, že můžeme poskytnout ostatním účastníkům řízeného networkingu Vaše osobní údaje (jméno, příjmení, firma).</div>
              <button
                @click="showPIDialog = false; allowPI = true; registerWorkshop(13);"
                class="mt-4 uppercase px-6 py-3 text-[16px] hover:opacity-80 text-black bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer"
              >
                Přihlásit se
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
  <div>
    <ProgramCardModal
      :programArticle="selectedProgramArticle"
      @close="clearSelectedArticle"
      :isWorkshop="true"
      :userLoggedIn="userLoggedIn"
      :workshopRegistrationOpened="workshopRegistrationOpened"
      @registerWorkshop="registerWorkshop"
      @unRegisterWorkshop="unRegisterWorkshop"
      :workshopRegistrationState="workshopRegistrationStateMutable"
    />
<!--    <div class="hidden md:block">-->
<!--&lt;!&ndash;      <Carousel :cardWidth="312" :visibleCards="4">&ndash;&gt;-->
<!--&lt;!&ndash;        <template v-slot:label>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="font-semibold text-heading">Workshop</p>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;          <div v-if="userLoggedIn">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;            <p v-if="maxWorkshopRegistrationsPerUser === 1" class="to-brand-gray-500 mt-2">Můžete se zúčastnit jen jednoho workshopu.</p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;            <p v-if="maxWorkshopRegistrationsPerUser > 1" class="to-brand-gray-500 mt-2">Můžete se zúčastnit jen {{ maxWorkshopRegistrationsPerUser }} workshopů.</p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;          </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;          <span v-else>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;            Pro zápis workshopu se prosím <a class="text-brand-blue" :href="route('frontend.login')">přihlašte</a>.&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;          </span>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->

<!--&lt;!&ndash;        <template v-slot:default>&ndash;&gt;-->
<!--&lt;!&ndash;          <div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div&ndash;&gt;-->
<!--&lt;!&ndash;              class="flex my-2"&ndash;&gt;-->
<!--&lt;!&ndash;              :key="key"&ndash;&gt;-->
<!--&lt;!&ndash;              v-for="(group, key) in workshopsGroupedByTime"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <ProgramCard&ndash;&gt;-->
<!--&lt;!&ndash;                v-for="(workshop, j) in group"&ndash;&gt;-->
<!--&lt;!&ndash;                :key="j"&ndash;&gt;-->
<!--&lt;!&ndash;                class="w-[472px]"&ndash;&gt;-->
<!--&lt;!&ndash;                :class="{ 'ml-4': j !== 0 }"&ndash;&gt;-->
<!--&lt;!&ndash;                :programArticle="workshop"&ndash;&gt;-->
<!--&lt;!&ndash;                @clicked="selectProgramArticle"&ndash;&gt;-->
<!--&lt;!&ndash;                @registerWorkshop="registerWorkshop"&ndash;&gt;-->
<!--&lt;!&ndash;                @unRegisterWorkshop="unRegisterWorkshop"&ndash;&gt;-->
<!--&lt;!&ndash;                :isWorkshop="true"&ndash;&gt;-->
<!--&lt;!&ndash;                :userLoggedIn="userLoggedIn"&ndash;&gt;-->
<!--&lt;!&ndash;                :registerGroupsCheck="registerGroupsCheck[key]"&ndash;&gt;-->
<!--&lt;!&ndash;                :workshopRegistrationState="workshopRegistrationStateMutable"&ndash;&gt;-->
<!--&lt;!&ndash;                :workshopRegistrationOpened="workshopRegistrationOpened"&ndash;&gt;-->
<!--&lt;!&ndash;                :maxWorkshopRegistrationsPerUser="&ndash;&gt;-->
<!--&lt;!&ndash;                  maxWorkshopRegistrationsPerUser&ndash;&gt;-->
<!--&lt;!&ndash;                "&ndash;&gt;-->
<!--&lt;!&ndash;              />&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--&lt;!&ndash;      </Carousel>&ndash;&gt;-->
<!--    </div>-->

    <div id="workshopy" class="mt-14">
      <p class="lg:text-[64px] text-[32px] font-semibold leading-9">Mastermind skupiny a řízený networking</p>
<!--      <div v-if="userLoggedIn">-->
<!--        <p v-if="maxWorkshopRegistrationsPerUser === 1" class="to-brand-gray-500 mt-2">Můžete se zúčastnit jen jednoho workshopu.</p>-->
<!--        <p v-if="maxWorkshopRegistrationsPerUser > 1" class="to-brand-gray-500 mt-2">Můžete se zúčastnit jen {{ maxWorkshopRegistrationsPerUser }} workshopů.</p>-->
<!--      </div>-->
<!--      <span v-else>-->
<!--        Pro zápis workshopu se prosím <a class="text-brand-blue" :href="route('frontend.login')">přihlašte</a>.-->
<!--      </span>-->

      <div
        class="my-2 flex flex-wrap mt-5 justify-center"
        :key="key"
        v-for="(group, key) in workshopsGroupedByTime"
      >
        <div
          v-for="(workshop, j) in group"
          :key="j"
        >
          <ProgramCard
            class="!max-w-[390px] !md:max-w-[440px]"
            :programArticle="workshop"
            @clicked="selectProgramArticle"
            @registerWorkshop="registerWorkshop"
            @unRegisterWorkshop="unRegisterWorkshop"
            :isWorkshop="true"
            :userLoggedIn="userLoggedIn"
            :registerGroupsCheck="registerGroupsCheck[key]"
            :workshopRegistrationState="workshopRegistrationStateMutable"
            :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
            :workshopRegistrationOpened="workshopRegistrationOpened"
            :workshopsGroupedByTime="workshopsGroupedByTime"
            v-if="workshop.id !== 13"
          />
        </div>

      </div>
      <div
        class="my-2 flex flex-wrap mt-5 justify-center"
        v-for="(group, key) in workshopsGroupedByTime"
      >
        <div
          v-for="(workshop, j) in group"
          :key="j"
        >
          <ProgramCard
            v-if="workshop.id === 13"
            class="!max-w-[390px] !md:max-w-[440px]"
            :programArticle="workshop"
            @clicked="selectProgramArticle"
            @registerWorkshop="registerWorkshop"
            @unRegisterWorkshop="unRegisterWorkshop"
            :isWorkshop="true"
            :userLoggedIn="userLoggedIn"
            :registerGroupsCheck="registerGroupsCheck[key]"
            :workshopRegistrationState="workshopRegistrationStateMutable"
            :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
            :workshopRegistrationOpened="workshopRegistrationOpened"
            :workshopsGroupedByTime="workshopsGroupedByTime"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";
import axios from "axios";
import { parse} from 'date-fns';
import {XIcon} from "@heroicons/vue/outline";
import {TransitionRoot} from "@headlessui/vue";

export default {
  components: {
    TransitionRoot,
    XIcon,
    ProgramCard,
    ProgramCardModal,
  },

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    userLoggedIn: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationState: {
      type: Object,
      default: () => {},
    },

    maxWorkshopRegistrationsPerUser: {
      type: Number,
    },

    maxRegistrationsPerWorkshop: {
      type: Number,
      default: 28
    },

    workshopRegistrationOpened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      workshopRegistrationStateMutable: this.workshopRegistrationState,
      registerGroupsCheck: {},
      allowPI: false,
      showPIDialog: false,
    };
  },

  watch: {
    workshopRegistrationStateMutable: {
      handler() {
        let times = Object.keys(this.workshopsGroupedByTime);
        times.forEach(startTime => {
          this.registerGroupsCheck[startTime] = this.userHasWorkshopRegisteredForGivenTimeSlot(startTime);
        })
      },
      immediate: true
    }
  },

  computed: {
    workshopsGroupedByTime() {
      const workshops = this.programEvents.filter(
        (event) => event.type === "workshop"
      );
      console.log('workshops: ', workshops);

      const grouped = workshops.reduce((groupedWorkshops, workshop) => {

        let parsedWorkshopEnd = parse(workshop.end, "HH:mm", new Date());

        if (groupedWorkshops[parsedWorkshopEnd] == null) {
          groupedWorkshops[parsedWorkshopEnd] = []
        }

        let capacity = this.maxRegistrationsPerWorkshop;
        if(workshop.id === 13){
          capacity = 50;
        }

        if(this.workshopRegistrationStateMutable.workshop_registrations[workshop.id]) {
          capacity -= this.workshopRegistrationStateMutable.workshop_registrations[workshop.id].count;
        }

        groupedWorkshops[parsedWorkshopEnd].push({ ...workshop, capacity: capacity });
        return groupedWorkshops;
      }, {});

      return Object.keys(grouped)
        .sort()
        .reduce((a, c) => ((a[c] = grouped[c]), a), {});
    },
  },

  methods: {
    selectProgramArticle(article) {
      this.selectedProgramArticle = article;
    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
    },

    userHasWorkshopRegisteredForGivenTimeSlot(workshopStartTime) {
      for(const workshopForTimeSlot of this.workshopsGroupedByTime[workshopStartTime]) {
        for(const registeredWorkshopId of this.workshopRegistrationStateMutable.user_registrations) {
          if(workshopForTimeSlot.id === registeredWorkshopId) {
            return true;
          }
        }
      }

      return false;
    },

    async registerWorkshop(workshopId) {
      if(workshopId === 13 && !this.allowPI){
        this.showPIDialog = true;
        return;
      }else{
        this.allowPI = false;
      }


      try {
        const res = await axios.post(
          `/api/workshop/${workshopId}/registration`,
          {}
        );
        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {}
    },

    async unRegisterWorkshop(workshopId) {
      try {
        const res = await axios.delete(
          `/api/workshop/${workshopId}/registration`,
          {}
        );

        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {}
    },
  },
};
</script>

<style>
</style>
